// extracted by mini-css-extract-plugin
export default {"inputWrapper":"ReferralPages-module__inputWrapper___Hixl","partnerCodeInputWrapper":"ReferralPages-module__partnerCodeInputWrapper__RE0wA"};